import { render, staticRenderFns } from "./AMCEditor.vue?vue&type=template&id=558ae05b"
import script from "./AMCEditor.vue?vue&type=script&lang=js"
export * from "./AMCEditor.vue?vue&type=script&lang=js"
import style0 from "./AMCEditor.vue?vue&type=style&index=0&id=558ae05b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports